import React from "react";
import { Layout, Row, Col } from "antd";
import { MenuOutlined } from "@ant-design/icons";

const { Header } = Layout;

interface TopHeaderProps {
  isMobile: boolean;
  onMenuClick: () => void;
}

const TopHeader: React.FC<TopHeaderProps> = ({ isMobile, onMenuClick }) => {
  return (
    <Header
      style={{
        background: "#FFF",
        borderBottom: "1px solid #CCC",
        padding: "10px 26px",
        height: "auto",
        lineHeight: "normal",
      }}
    >
      <Row justify="space-between" align="middle" gutter={20}>
        <Col flex="auto">
          <Row align="middle" gutter={20}>
            {isMobile && (
              <Col>
                <MenuOutlined
                  onClick={onMenuClick}
                  style={{ 
                    fontSize: "20px", 
                    cursor: "pointer",
                    color: "#4D4D4D",
                    padding: "8px",
                    borderRadius: "4px",
                    transition: "all 0.3s ease"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                />
              </Col>
            )}
            <Col>
              <div
                style={{
                  color: "#AAA",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "1",
                  textTransform: "uppercase",
                }}
              >
                Program Administrator Portal
              </div>
            </Col>
          </Row>
        </Col>

        <Col flex="none">
          <Row align="middle" gutter={20} wrap={false}>
            <Col>
              <div
                style={{
                  alignItems: "center",
                  borderRadius: "6px",
                  display: "flex",
                  padding: "10px 15px",
                  gap: "15px",
                  color: "#FFF",
                  justifyContent: "start",
                  backgroundColor: "#DF701F",
                  flexShrink: 1,
                  minWidth: "300px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                  }}
                >
                  <div
                    style={{
                      color: "#FFF",
                      fontSize: "20px",
                      fontWeight: "700",
                      lineHeight: "1.2",
                    }}
                  >
                    $230,500.00
                  </div>
                  <div
                    style={{
                      color: "#FFF",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "1",
                    }}
                  >
                    Remaining Program Funds
                  </div>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid #FFF",
                    height: "40px",
                    width: "1px",
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                  }}
                >
                  <div
                    style={{
                      color: "#FFF",
                      fontSize: "20px",
                      fontWeight: "700",
                      lineHeight: "1.2",
                    }}
                  >
                    $120,100.00
                  </div>
                  <div
                    style={{
                      color: "#FFF",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "1",
                    }}
                  >
                    Payments Funded
                  </div>
                </div>
              </div>
            </Col>

            <Col>
              <div
                style={{
                  borderRadius: "24px",
                  marginTop: "auto",
                  marginBottom: "auto",
                  minHeight: "48px",
                  padding: "0 18px",
                  fontSize: "20px",
                  color: "#FFF",
                  fontWeight: "700",
                  textAlign: "center",
                  lineHeight: "48px",
                  width: "48px",
                  height: "48px",
                  backgroundColor: "#4979A7",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                A
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Header>
  );
};

export default TopHeader;
